export default "__VITE_ASSET__BkavxH3d__"